import React from 'react';
import { useParams } from 'react-router-dom';
import EditUserFrame from './UsersFrameComponent';

const EditUser = ({ users, roles, refreshData, setNotification, permisos }) => {
	const { id } = useParams();
	const user = users.find((e) => e._id === id);

	return <EditUserFrame user={user} refreshData={refreshData} roles={roles} setNotification={setNotification} permisos={permisos} />;
};

export default EditUser;
